import clsx from 'clsx'

interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
  className?: string
}

export default function Switch({ checked, onChange, label, disabled = false, className }: SwitchProps) {
  return (
    <label className={clsx('inline-flex items-center gap-3 cursor-pointer', disabled && 'opacity-50 pointer-events-none', className)}>
      <button
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        disabled={disabled}
        className={clsx(
          'relative h-6 w-11 rounded-full transition-colors',
          checked ? 'bg-brand-500' : 'bg-gray-300',
        )}
      >
        <span className={clsx(
          'absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow-xs transition-transform',
          checked && 'translate-x-5',
        )} />
      </button>
      {label && <span className="text-sm text-gray-700">{label}</span>}
    </label>
  )
}
